import { faArrowUp, faArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface PercentageCardProps {
	title: string;
	percentage: number;
	changePercentage?: number;
	isPositive?: boolean;
	className?: string;
}

export const PercentageCard = ({ title, percentage, changePercentage, isPositive = true, className = '' }: PercentageCardProps) => {
	const formatPercentage = (value: number) => {
		return `${value.toFixed(2)} %`;
	};

	return (
		<div className={`bg-white rounded-2xl shadow-sm border border-gray-100 p-6 relative ${className}`}>
			<h3 className="text-gray-600 text-sm font-medium mb-4">{title}</h3>

			<div className="text-4xl font-bold text-gray-900 mb-6">{formatPercentage(percentage)}</div>

			{changePercentage !== undefined && (
				<div className="absolute bottom-4 right-4">
					<div
						className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-sm font-medium ${
							isPositive ? 'bg-green-50 text-green-700' : 'bg-[#fee2e2] text-red-700'
						}`}
					>
						<FontAwesomeIcon icon={isPositive ? faArrowUp : faArrowDown} className="h-3 w-3" />
						<span>{Math.abs(changePercentage)}%</span>
					</div>
				</div>
			)}
		</div>
	);
};
